import React from 'react';

import StatusTag from '../../../../ui-components/StatusTag';
import { ActionMenu, ActionMenuItem } from '../../../../ui-components/listing';
import UserAvatar from '../../../../ui-components/UserAvatar';

interface AdminTableRowProps {
  name?: string;
  email?: string;
  roleLabel?: string;
  status?: string;
  addedDateLabel?: string;
  avatarUrl?: string;
  siteName?: string;
  buildingName?: string;
  floorName?: string;
  actions: ActionMenuItem[];
}

export const buildAdminTableCells = ({
  name,
  email,
  roleLabel,
  status,
  addedDateLabel,
  avatarUrl,
  siteName,
  buildingName,
  floorName,
  actions,
}: AdminTableRowProps): React.ReactNode[] => [
  <div className="flex items-center gap-3 min-w-0" key="name">
    <UserAvatar
      src={avatarUrl}
      alt={name || 'Admin'}
      size="sm"
      objectPosition="50% 30%"
      className="grayscale hover:grayscale-0 transition-all duration-300 cursor-pointer"
    />
    <span className="text-sm text-neutral-900 dark:text-neutral-100 truncate">
      {name || '-'}
    </span>
  </div>,
  <span
    className="text-sm text-neutral-600 dark:text-neutral-400 truncate"
    key="role"
  >
    {roleLabel || '-'}
  </span>,
  <span
    className="text-sm text-neutral-600 dark:text-neutral-400 truncate"
    key="email"
  >
    {email || '-'}
  </span>,
  <StatusTag value={status} key="status" />,
  <span
    className="text-sm text-neutral-600 dark:text-neutral-400 truncate"
    key="added-date"
  >
    {addedDateLabel || '-'}
  </span>,
  <span
    className="text-sm text-neutral-600 dark:text-neutral-400 truncate"
    key="site"
  >
    {siteName || '-'}
  </span>,
  <span
    className="text-sm text-neutral-600 dark:text-neutral-400 truncate"
    key="building"
  >
    {buildingName || '-'}
  </span>,
  <span
    className="text-sm text-neutral-600 dark:text-neutral-400 truncate"
    key="floor"
  >
    {floorName || '-'}
  </span>,
  <div className="flex justify-end" key="actions">
    <ActionMenu
      items={actions}
      showIcons
      buttonClassName="hover:bg-neutral-100 dark:hover:bg-neutral-800"
      iconClassName="text-neutral-600 dark:text-neutral-400"
    />
  </div>,
];

export default buildAdminTableCells;
